import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { LPadrao } from "@/layouts"
  import { ref } from "vue"
  import { MenuItem } from "primevue/menuitem"
  import { TGestaoTravamento } from "@/components/Atividades"
  import { useI18n } from "vue-i18n"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'GestaoTravamento',
  setup(__props) {

  const { t } = useI18n()

  const rotaBase = ref<MenuItem>({
    label: t("gestaoDeTravamentos"),
    icon: "pi pi-lock",
    to: "/gestao-travamentos",
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(LPadrao), null, {
    default: _withCtx(() => [
      _createVNode(_unref(TGestaoTravamento), { "rota-base": rotaBase.value }, null, 8, ["rota-base"])
    ]),
    _: 1
  }))
}
}

})